// Testimonials.jsx — No circle/orbit; clean grid with gradient cards (white bg)
import React from "react";

const STORIES = [
  {
    quote: "We cut our cost-per-lead by ~40% in 30 days.",
    author: "D2C Brand",
    role: "Head of Growth",
  },
  {
    quote: "Loan queries are 60% faster to resolve over chat.",
    author: "Banking",
    role: "Product Manager",
  },
  {
    quote: "Bookings tripled in a month after moving to WA.",
    author: "Local Services",
    role: "Owner",
  },
  {
    quote: "Response times fell from hours to minutes with WhatsApp.",
    author: "EdTech",
    role: "CX Lead",
  },
  {
    quote: "Our demo-to-win conversion improved by 2.2×.",
    author: "SaaS",
    role: "Growth PM",
  },
  {
    quote: "Catalog + payments in chat = 31% more completed orders.",
    author: "Marketplace",
    role: "Product Ops",
  },
];

const Testimonials = () => {
  const styles = `
    :root, html, body { background:#ffffff; }
    .ts-wrap, .ts-wrap * { box-sizing: border-box; }

    .ts-wrap{
      max-width: 1450px;
      margin: 0 auto;
      padding: 56px 60px 72px;
      background: #ffffff;
      color: #0f172a;
      font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial;
    }

    /* Title + tagline (your sizes) */
    .ts-head{ text-align:center; margin-bottom: 28px; }
    .ts-title{ margin:0; font-size:2.5rem; font-weight:800; line-height:1.12; letter-spacing:.2px; }
    .ts-tag{ margin:12px auto 0; max-width:720px; font-size:1rem; color:#64748b; }

    /* Gradient cards grid */
    .ts-grid{
      display:grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 22px;
      margin-top: 10px;
    }

    .ts-card{
      border-radius:16px;
      padding:2px;                            /* gradient border thickness */
      background: linear-gradient(135deg,#e6f7ff,#f6fff9);
      transition: transform .12s ease, box-shadow .2s ease;
    }
    .ts-card:hover{
      transform: translateY(-2px);
      box-shadow: 0 10px 22px rgba(2,6,23,.08);
    }

    .inner{
      background:#fff;
      border:1px solid #e6edf5;
      border-radius:14px;
      padding:18px 20px;
      height:100%;
    }

    .ts-quote{ margin:0 0 12px; font-style:italic; line-height:1.6; }
    .ts-byline{ display:flex; align-items:center; gap:8px; color:#64748b; font-size:.95rem; }
    .ts-author{ color:#0f172a; font-weight:700; }
    .ts-sep{ opacity:.7; }
    .ts-role{ color:#64748b; }

    /* Responsive */
    @media (max-width:1100px){ .ts-grid{ grid-template-columns: repeat(2,1fr); } }
    @media (max-width:720px){
      .ts-wrap{ padding:40px 20px 56px; }
      .ts-grid{ grid-template-columns: 1fr; }
    }
  `;

  return (
    <div className="ts-wrap">
      <header className="ts-head">
        <h2 className="ts-title">Customer stories</h2>
        <p className="ts-tag">
          Outcomes teams achieved with click-to-WhatsApp campaigns.
        </p>
      </header>

      {/* Only gradient cards — no circle/orbit */}
      <section className="ts-grid">
        {STORIES.map((s, i) => (
          <div className="ts-card" key={i}>
            <div className="inner">
              <p className="ts-quote">“{s.quote}”</p>
              <div className="ts-byline">
                <span className="ts-author">{s.author}</span>
                <span className="ts-sep">·</span>
                <span className="ts-role">{s.role}</span>
              </div>
            </div>
          </div>
        ))}
      </section>

      <style>{styles}</style>
    </div>
  );
};

export default Testimonials;
